import React, { ReactElement } from 'react';
import Image from '../image/image.component';
import useStylesLocationMapMarker from './location-map-marker.styles';

const LocationMapMarker: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    title,
    amount,
    imageLink,
  } = props;

  const { classes } = useStylesLocationMapMarker();

  return (
    <div>
      {
        !!imageLink && (
          <div className={classes.locationMapMarkerImageBlock}>
            <Image isDefault text={title || ''} link={imageLink} className={classes.locationMapMarkerImage} />
          </div>
        )
      }
      <div className={classes.locationMapMarkerTextBlock}>
        {
          !!title && (
            <div className={classes.locationMapMarkerTextTitle}>
              {title}
            </div>
          )
        }
        {
          !!amount && (
            <div className={classes.locationMapMarkerTextAmount}>
              {amount}
            </div>
          )
        }
      </div>
    </div>
  );
});

export default LocationMapMarker;
